<ng-container *ngIf="actionType !== 'moderation'">
	<app-form-view [contentLoader]="loader" [popup]="true" (helpTriggered)="helpTriggered = $event">
		<form-title>
			{{locale.translate('knowledge_bead')}}
		</form-title>
		<content-area>
			<div class="knowledge-card-bead" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<ng-container *ngIf="actionType === 'initial' || actionType === 'format'">

						<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
							<div class="page" fxLayout="row" fxLayoutAlign="center center">
								<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
									fxLayoutGap.xs="10px">
									<ng-container *ngIf="actionType === 'initial'">
										<p class="caption">
											{{locale.translate('share_your_thoughts_knowledge')}}
										</p>
									</ng-container>
									<ng-container *ngIf="formFields?.length">
										<div fxLayout="column" fxLayoutAlign="start stretch" class="form-container">
											<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
												fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)"
												(multiTypeUploadRemoved)="fileRemoved($event)" (multiTypeUploadDropped)="fileDropped($event)">
											</app-form-group>
											<ng-container *ngIf="showDescription && actionType === 'format'">
												<div class="card-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
													<p class="hyperlink" (click)="addDescription()">
														{{locale.translate('add_a_description')}}</p>
												</div>
											</ng-container>
										</div>
									</ng-container>
									<ng-container *ngIf="actionType === 'initial'">
										<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
											<div class="create-page cursor-pointer" fxLayout="row" fxLayoutAlign="center center"
												fxLayoutGap="10px" (click)="addPage()">
												<mat-icon svgIcon="pages"></mat-icon>
												<p class="caption">
													{{locale.translate('create_a_page')}}
												</p>
											</div>
										</div>
									</ng-container>
									<ng-container *ngIf="actionType === 'format'">
										<div fxLayout="column" fxLayoutAlign="start stretch">
											<app-alert id="knowledgeCardBead"></app-alert>
											<ng-container *ngIf="actionType === 'format' || pageData">
												<div class="button-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
													<button class="icon-btn" mat-icon-button (click)="submitBead()" [disabled]="submitDisable">
														<mat-icon>arrow_forward</mat-icon>
													</button>
												</div>
											</ng-container>
										</div>
									</ng-container>
								</div>
							</div>
						</div>
					</ng-container>

					<ng-container *ngIf="actionType === 'page'">
						<div fxFlex="100%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
							<div class="page" fxLayout="row" fxLayoutAlign="center center">
								<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
									fxLayoutGap.xs="10px">

									<ng-container *ngIf="formFields?.length">
										<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" class="form-container">

											<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
												fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
											</app-form-group>

											<div class="button-block" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
												<button class="editor-btn main-action-2" mat-raised-button (click)="submitPage()"
													[disabled]="submitDisable">
													{{locale.translate('done')}}
												</button>
											</div>

										</div>
									</ng-container>

								</div>
							</div>
						</div>

					</ng-container>
					<ng-container *ngIf="actionType === 'pageFormat'">
						<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
							<div class="page" fxLayout="row" fxLayoutAlign="center center">
								<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
									fxLayoutGap.xs="10px">
									<ng-container *ngIf="formFields?.length">
										<div fxLayout="column" fxLayoutAlign="start stretch" class="form-container">
											<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
												fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)"
												(multiTypeUploadRemoved)="fileRemoved($event)" (multiTypeUploadDropped)="fileDropped($event)">
											</app-form-group>
											<ng-container *ngIf="showDescription">
												<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
													<p class="card-title hyperlink" fxFlex="1 1" fxFlex.xs="auto" (click)="addDescription()">
														{{locale.translate('add_a_description')}}</p>
												</div>
											</ng-container>
											<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<ng-container *ngIf="![null,undefined].includes(pageData)">
													<div class="page-field-content" [innerHtml]="pageData | safeDom">
													</div>
												</ng-container>
												<div class="button-block" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
													<button class="editor-btn main-action-2" mat-raised-button (click)="updatePage()"
														[disabled]="submitDisable">
														{{locale.translate('edit')}}
													</button>
												</div>
											</div>
										</div>
									</ng-container>
									<div fxLayout="column" fxLayoutAlign="start stretch">
										<app-alert id="knowledgeCardBead"></app-alert>
										<div class="button-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
											<button class="icon-btn" mat-icon-button (click)="submitBead()" [disabled]="submitDisable">
												<mat-icon>arrow_forward</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>

					<ng-container *ngIf="actionType === 'skillSelection'">
						<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">

							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px" class="bead-detail">
								<loader [loader]="formLoader" [type]="'general'"></loader>
								<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="bead-view">
									<ng-container *ngIf="beadData?.type === 'embed'">
										<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxFlex="95" fxFlex.xs="100">
											<ng-container *ngIf="beadData?.data?.embed?.image">
												<div fxFlex="0 0 150px" fxFlex.xs="100%">
													<div class="thumbnail">
														<img [src]="beadData?.data?.embed?.image" alt="">
													</div>
												</div>
											</ng-container>
											<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<a [attr.href]="beadData?.data?.embed?.link" target="_blank"
													class="bead-title linkable">{{beadData?.data?.embed?.title}}</a>
											</div>
										</div>
									</ng-container>
									<ng-container *ngIf="beadData?.type === 'image'">
										<ng-container *ngFor="let imageData of beadData?.data?.format;let first = first;">
											<ng-container *ngIf="first">
												<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxFlex="95" fxFlex.xs="100">
													<div fxFlex="0 0 150px" fxFlex.xs="100%">
														<div class="thumbnail">
															<img [src]="imageData?.thumbnailSrc" alt="">
														</div>
													</div>
													<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
														<p class="bead-title">{{beadData?.data?.title}}</p>
													</div>
												</div>
											</ng-container>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="beadData?.type === 'video'">
										<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxFlex="95" fxFlex.xs="100">
											<ng-container *ngIf="beadData?.data?.format?.thumbnailSrc">
												<div fxFlex="0 0 150px" fxFlex.xs="100%">
													<div class="thumbnail">
														<img [src]="beadData?.data?.format?.thumbnailSrc" alt="">
													</div>
												</div>
											</ng-container>
											<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<p class="bead-title">{{beadData?.data?.title}}</p>
											</div>
										</div>
									</ng-container>
									<ng-container *ngIf="beadData?.type === 'audio'">
										<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxFlex="95" fxFlex.xs="100">
											<ng-container *ngIf="beadData?.data?.format?.thumbnailSrc">
												<div fxFlex="0 0 150px" fxFlex.xs="100%">
													<div class="thumbnail">
														<img [src]="beadData?.data?.format?.thumbnailSrc" alt="">
													</div>
												</div>
											</ng-container>
											<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<p class="bead-title">{{beadData?.data?.title}}</p>
											</div>
										</div>
									</ng-container>
									<ng-container *ngIf="beadData?.type === 'document'">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="95" fxFlex.xs="100">
											<mat-icon svgIcon="document"></mat-icon>
											<p class="bead-title">{{beadData?.data?.title}}</p>
										</div>
									</ng-container>
									<ng-container *ngIf="beadData?.type === 'page'">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="95" fxFlex.xs="100">
											<mat-icon svgIcon="pages"></mat-icon>
											<p class="bead-title">{{beadData?.data?.title}}</p>
										</div>
									</ng-container>
								</div>
								<ng-container *ngIf="!formLoader">
									<div fxLayout="row" fxLayoutAlign="center center">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
											fxLayoutGap.xs="10px">
											<!-- <div fxLayout fxLayoutAlign="center start" class="form-container">
												<app-form-group [fieldList]="skillFormFields" [config]="config" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
													fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="skillFormObjectReader($event)">
												</app-form-group>
											</div> -->

											<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<ng-container *ngIf="keywordFormFields?.length">
													<div class="block-title"> {{ locale.translate('keywords') }} </div>
												</ng-container>
												<div fxLayout fxLayoutAlign="center start" class="form-container">
													<app-form-group [fieldList]="keywordFormFields" [formObjectData]="formObjectData"
														[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
														fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
														(formObject)="keywordFormReader($event)">
													</app-form-group>
												</div>
											</div>
											<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<ng-container *ngIf="skillFormFields?.length">
													<ng-container *ngIf="skillMPermission">
														<div class="block-title"> {{ locale.translate('related_skills') }} </div>
													</ng-container>
												</ng-container>
												<div fxLayout fxLayoutAlign="center start" class="form-container">
													<app-form-group [fieldList]="skillFormFields" [formObjectData]="formObjectData"
														[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
														fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
														(formObject)="keywordFormReader($event)">
													</app-form-group>
												</div>
											</div>
											<div fxLayout="column" fxLayoutAlign="start stretch">
												<app-alert id="knowledgeCardBead"></app-alert>
												<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="button-block">
													<button class="icon-btn" mat-icon-button (click)="navigateToBack()"
														[disabled]="submitDisable">
														<mat-icon>arrow_back</mat-icon>
													</button>
													<button class="icon-btn" mat-icon-button (click)="checkBead()" [disabled]="submitDisable">
														<mat-icon>done</mat-icon>
													</button>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</ng-container>

				</div>
			</div>
		</content-area>
		<insights>
			<app-help></app-help>
		</insights>
	</app-form-view>
</ng-container>

<ng-container *ngIf="actionType === 'moderation'">
	<app-form-view [contentLoader]="loader" [popup]="true">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="bead-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">

						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="10px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="info">
											<div class="form-info">
												<p class="body-text">
													{{info}}
												</p>
											</div>
										</ng-container>
										<ng-container *ngIf="formFields?.length">
											<div class="body-text"> {{ locale.translate('who_are_you_reporting_to') }} </div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
												fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
											</app-form-group>
										</div>
									</div>
									<app-alert id="courseAlert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="moderationSubmit()" mat-stroked-button
											class="submit-btn" type="button">{{locale.translate('ok')}}</button>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>
